import _ from 'lodash';

export default {
  methods: {
    createInputClass(error, field) {
      if (_.has(this.error, field)) {
        return 'is-invalid';
      }
      return '';
    },
  },
};
